import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";

import {
  addUnit,
  updateUnit,
  getUnitById,
} from "../services/unitService";

import "./AddOutletLayer.css";

const AddUnitLayer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [form, setForm] = useState({
    unit_name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  /* LOAD UNIT (EDIT MODE) */
  useEffect(() => {
    if (isEdit) loadUnit();
  }, [id]);

  const loadUnit = async () => {
    try {
      const res = await getUnitById(id);
      console.log("Unit API Response:", res);

      if (res?.status === "success" && res.data) {
        const unit = Array.isArray(res.data)
          ? res.data[0]
          : res.data;

        setForm({
          unit_name: unit.unit_name || "",
          description: unit.description || "",
        });
      } else {
        toast.error("Unit not found");
      }
    } catch {
      toast.error("API Error while loading unit");
    }
  };

  /* HANDLE INPUT */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /* VALIDATION */
  const validateForm = () => {
    let temp = {};
    if (!form.unit_name.trim())
      temp.unit_name = "Unit name required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Required fields missing");
      return;
    }

    setLoading(true);

    try {
      const res = isEdit
        ? await updateUnit(id, form)
        : await addUnit(form);

      if (res.status === "success") {
        toast.success(res.message || "Success");
        navigate("/unit-list");
      } else {
        toast.error(res.message);
      }
    } catch {
      toast.error("API Error");
    }

    setLoading(false);
  };

  return (
    <div className="container mt-3 mb-5">
      <div className="addoutlet-wrapper">
        <h4 className="addoutlet-title">
          {isEdit ? "Update Unit" : "Add Unit"}
        </h4>

        <form className="addoutlet-form" onSubmit={handleSubmit}>
          {/* UNIT NAME */}
          <div className="mb-3">
            <label>Unit Name *</label>
            <input
              name="unit_name"
              className="addoutlet-input"
              value={form.unit_name}
              onChange={handleChange}
            />
            {errors.unit_name && (
              <p className="addoutlet-error">{errors.unit_name}</p>
            )}
          </div>

          {/* DESCRIPTION */}
          <div className="mb-3">
            <label>Description</label>
            <textarea
              name="description"
              className="addoutlet-textarea"
              rows="4"
              value={form.description}
              onChange={handleChange}
            />
          </div>

          {/* BUTTONS */}
          <div className="d-flex gap-3 mt-4">
            <button
              className="addoutlet-btn-primary"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : isEdit
                ? "Update Unit"
                : "Add Unit"}
            </button>

            <Link to="/unit-list" className="addoutlet-btn-secondary">
              Back
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUnitLayer;
